<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>运营管理</el-breadcrumb-item>
            <el-breadcrumb-item>意见反馈列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-input placeholder="请输入用户名" clearable v-model="queryInfo.username" @clear="getList()" style="width: 300px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-select v-model="queryInfo.storeId" placeholder="请选择门店" @change="getList()" style="margin-left:10px" clearable filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.status" clearable placeholder="处理状态" @change="getList()" style="margin-left: 10px">
                        <el-option label="已处理" :value="1"></el-option>
                        <el-option label="待处理" :value="0"></el-option>
                    </el-select>
                    <el-select v-model="queryInfo.category" clearable placeholder="反馈类型" @change="getList()" style="margin-left: 10px">
                        <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-button
                        type="primary"
                        icon="el-icon-upload"
                        style="margin-left: 10px"
                        @click="exportExcel"
                        :loading="exportLoading"
                        v-permission="'menu:operations:feedback:export'"
                    >导出Excel</el-button>
                </el-col>
            </el-row>
            <br>
            <el-table :data="list" :key="list.index" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index" width="50"></el-table-column>
                <el-table-column label="用户" prop="username" width="120"></el-table-column>
                <el-table-column label="门店" prop="storeName" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column label="反馈类型" prop="category" width="120"></el-table-column>
                <el-table-column label="反馈内容" prop="content" width="320" show-overflow-tooltip></el-table-column>
                <el-table-column label="回复信息" prop="reply" width="280">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.reply" :content="scope.row.reply" placement="top" :disabled="!scope.row.reply || scope.row.reply.length <= 50">
                            <span>{{ getFirstReply(scope.row.reply) }}</span>
                        </el-tooltip>
                        <span v-else style="color: #ccc;">暂无回复</span>
                    </template>
                </el-table-column>
                <el-table-column label="图片" width="120">
                    <template slot-scope="scope">
                        <template v-if="parseImages(scope.row.images).length">
                            <el-popover v-for="(img, idx) in parseImages(scope.row.images)" :key="idx" placement="bottom" width="400" trigger="click">
                                <div style="text-align: center;"><img :src="resolveImageUrl(img)" style="width:380px"></div>
                                <img :src="resolveImageUrl(img)" style="width:30px;height:30px;margin-right:4px;" slot="reference">
                            </el-popover>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="提交时间" prop="createTime" width="175"></el-table-column>
                <el-table-column label="处理状态" width="100">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 1" type="success">已处理</el-tag>
                        <el-tag v-else type="info">待处理</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.status != 1"
                            type="primary"
                            icon="el-icon-edit"
                            size="mini"
                            @click="openReplyDialog(scope.row)"
                            v-permission="'btn:operations:feedback:reply'">回复</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)" v-permission="'btn:operations:feedback:delete'"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNum" :page-sizes="[20,50,500,1000]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-card>

        <el-dialog title="回复意见反馈" :visible.sync="replyDialogVisible" width="60%">
            <el-form ref="replyFormRef" :model="replyForm" :rules="replyRules" label-width="100px">
                <el-form-item label="用户">
                    <el-input v-model="replyForm.username" readonly></el-input>
                </el-form-item>
                <el-form-item label="反馈类型">
                    <el-input v-model="replyForm.category" readonly></el-input>
                </el-form-item>
                <el-form-item label="反馈内容">
                    <el-input type="textarea" v-model="replyForm.content" readonly :rows="3"></el-input>
                </el-form-item>
                <el-form-item label="回复内容" prop="reply" required>
                    <el-input type="textarea" v-model="replyForm.reply" placeholder="请输入回复内容" :rows="4"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="replyDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitReply" :loading="btnLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            queryInfo: {
                username: '',
                storeId: '',
                status: '',
                category: '',
                pageNum: 1,
                pageSize: 20
            },
            categoryOptions: ['软件功能', '场馆服务', '增加器械', '活动优惠', '体验改进', '我要投诉'],
            total: 0,
            list: [],
            storelist: [],
            admin_token: '',
            exportLoading: false,
            replyDialogVisible: false,
            btnLoading: false,
            replyForm: {
                id: null,
                username: '',
                category: '',
                content: '',
                reply: ''
            },
            replyRules: {
                reply: [
                    { required: true, message: '请输入回复内容', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.admin_token = window.sessionStorage.getItem('admin_token')
        this.getList()
        this.GetStore()
    },
    methods: {
        async GetStore() {
            const { data: res } = await this.$http.get('store/')
            if (res.status == 0) {
                this.storelist = res.data
            }
        },
        async getList() {
            const { data: res } = await this.$http.get('feedbacklist/', { params: this.queryInfo })
            if (res.code === 0 || res.status === 0) {
                this.total = res.totalSize || 0
                this.list = res.data || []
            }
        },
        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize
            this.getList()
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage
            this.getList()
        },
        async exportExcel() {
            this.exportLoading = true
            try {
                const params = new URLSearchParams()
                if (this.queryInfo.username) params.append('username', this.queryInfo.username)
                if (this.queryInfo.storeId) params.append('storeId', this.queryInfo.storeId)
                if (this.queryInfo.status !== '') params.append('status', this.queryInfo.status)
                if (this.queryInfo.category) params.append('category', this.queryInfo.category)

                const response = await this.$http.get('feedbacklist/export', {
                    params: this.queryInfo,
                    responseType: 'blob'
                })

                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-')
                link.download = `意见反馈数据_${timestamp}.xlsx`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)

                this.$message.success('导出成功')
            } catch (error) {
                console.error('导出失败:', error)
                this.$message.error('导出失败，请稍后重试')
            } finally {
                this.exportLoading = false
            }
        },
        async DelInfo(id) {
            const confirmResult = await this.$confirm('是否要删除此反馈?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已取消删除！')
            }
            const { data: res } = await this.$http.get('feedbackdel/' + id)
            if (res.code === 0) {
                this.$message({ message: res.msg || '删除成功！', type: 'success' })
            } else {
                this.$message.error(res.msg || '删除失败')
            }
            this.getList()
        },
        openReplyDialog(row) {
            if (row.status == 1) {
                this.$message.warning('该反馈已回复，不可重复回复')
                return
            }
            this.replyForm.id = row.id
            this.replyForm.username = row.username
            this.replyForm.category = row.category
            this.replyForm.content = row.content
            this.replyForm.reply = ''
            this.replyDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.replyFormRef) {
                    this.$refs.replyFormRef.clearValidate()
                }
            })
        },
        async submitReply() {
            const valid = await this.$refs.replyFormRef.validate().catch(() => false)
            if (!valid) {
                return
            }

            this.btnLoading = true
            try {
                const { data: res } = await this.$http.post('feedbackreply/', {
                    id: this.replyForm.id,
                    reply: this.replyForm.reply.trim()
                })

                if (res.code === 0) {
                    this.$message.success(res.msg || '回复成功')
                    this.replyDialogVisible = false
                    this.getList()
                } else {
                    this.$message.error(res.msg || '回复失败')
                }
            } catch (error) {
                this.$message.error('请求失败，请稍后重试')
            } finally {
                this.btnLoading = false
            }
        },
        parseImages(images) {
            if (!images) return []
            if (Array.isArray(images)) return images
            if (typeof images !== 'string') return []
            const trimmed = images.trim()
            if (!trimmed) return []
            try {
                const parsed = JSON.parse(trimmed)
                return Array.isArray(parsed) ? parsed : [parsed]
            } catch (e) {
                return trimmed.split(',').map(s => s.trim().replace(/^["']|["']$/g, '')).filter(Boolean)
            }
        },
        resolveImageUrl(url) {
            if (!url) return ''
            const path = String(url).trim()
            if (path.startsWith('http://') || path.startsWith('https://')) {
                return path
            }
            const base = (this.GLOBAL.imgURL || this.GLOBAL.imgURL_Front || '').replace(/\/$/, '')
            if (path.startsWith('/uploads/') || path.startsWith('uploads/')) {
                return base + (path.startsWith('/') ? path : '/' + path)
            }
            if (path.startsWith('/profile/') || path.startsWith('profile/')) {
                return base + (path.startsWith('/') ? path : '/' + path)
            }
            if (path.startsWith('/')) {
                return base + path
            }
            if (path.startsWith('static/')) {
                return base + '/' + path
            }
            return base + '/static/' + path
        },
        getFirstReply(reply) {
            if (!reply) return ''
            const text = reply.trim()
            if (text.length > 50) {
                return text.substring(0, 50) + '...'
            }
            return text
        }
    }
}
</script>
